module.exports = __webpack_public_path__ + "img/freespin4.1c65a4c7.png";